<template>
  <v-layout>
  </v-layout>
</template>

<script>
import VLayout from "@/layouts/Empty";

export default {
  name: "shopping-cart-payment-done-iframe",
  components: {
    VLayout,
  },
  mounted: function() {
    parent.postMessage({ event: "payment-transaction-success", data: {} }, "*");
  },
};
</script>
